<template>
    <v-container fill-height class="align-start">
        <v-row
            no-gutters
            class="align-self-center"
            align="center"
            justify="center"
        >
            <v-col
                cols="auto"
                class="form">
                <v-card
                    class="elevation-12"
                    width="89vw"
                    max-width="400px"
                >
                    <v-toolbar
                        color="primary"
                        dark
                        flat
                    >
                        <v-toolbar-title>Set Rate Alert</v-toolbar-title>
                        <v-spacer />
                        <v-btn
                            :disabled="creatingRateAlert"
                            text
                            outlined
                            dark
                            class="align-self-center pr-2 pl-3 mr-1"
                            @click="createRateAlert"
                        >
                            Add Alert<v-icon class="ml-2">mdi-plus</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-tabs
                        v-if="rateAlerts.length>0"
                        v-model="selectedTab"
                        background-color="grey lighten-4"
                        color="primary"
                        light
                        show-arrows
                    >
                        <v-tab
                            v-for="alert in rateAlerts"
                            :key="alert.id"
                            @click="select(alert)"
                        >
                            <template v-if="!!alert.poster_currency && !!alert.matcher_currency">
                                {{ alert.poster_currency }}/{{ alert.matcher_currency }}
                            </template>
                            <template v-else>
                                Creating New Alert
                            </template>
                        </v-tab>
                    </v-tabs>
                    <alertForm
                        :alert="selectedAlert"
                        :loading="loading"
                        @loading="pushToLoading"
                        @updateTabs="getRateAlerts()"
                    />
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import formatCurrency from '../modules/formatCurrency';
    import alertForm from './alert-form.vue';

    const currency = require('./../modules/currency');

    export default {
        name: 'RateAlert',
        components: { alertForm },
        filters: {
            currency(amount) {
                return formatCurrency(amount);
            },
        },
        data,
        computed: getComputed(),
        created,
        mounted,
        methods: getMethods(),
    };

    function data() {
        return {
            currencies: currency.currencies,
            selectedTab: 0,
            rateAlerts: [],
            selectedAlert: undefined,
            loading: [],
        };
    }

    function getComputed() {
        return {
            creatingRateAlert,
        };

        function creatingRateAlert() {
            const vm = this;
            if (vm.rateAlerts.length > 0) {
                if (vm.rateAlerts[vm.rateAlerts.length - 1].poster_currency) {
                    return false;
                }
            }
            return true;
        }
    }

    function created() {
        const vm = this;
        vm.loading.push('loading rate alerts');
        vm.getRateAlerts();
    }

    function mounted() {
        const vm = this;
        vm.$store.commit('pageHeaderClass', 'rateAlert');
        vm.$store.commit('pageHeaderTitle', 'Rate Alert');
    }

    function getMethods() {
        return {
            createRateAlert,
            getRateAlerts,
            pushToLoading,
            select,
        };

        /**
         * adds an empty object to the end of rateAlerts
         * adds and selects a new tab
         * sets selectedAlert as undefined so props' default data can be used
         */
        function createRateAlert() {
            const vm = this;
            vm.rateAlerts.push({ id: '999999' }); // creates tab, gives new alert object an id for key
            vm.selectedTab = vm.rateAlerts.length - 1;
            vm.selectedAlert = undefined;
        }

        function getRateAlerts() {
            const vm = this;
            vm.pushToLoading('loading rate alerts');
            Vue.backendApi().user(vm.$store.state.user.id).getRateAlerts().then(success, error);

            function success(response) {
                vm.loading = vm.loading.filter((element) => element !== 'loading rate alerts');
                vm.loading = vm.loading.filter((element) => element !== 'rate alert');
                Vue.set(vm, 'rateAlerts', response.data);
                vm.rateAlerts.forEach((rate, index) => {
                    vm.rateAlerts[index].poster_currency = rate.poster_currency.toUpperCase();
                    vm.rateAlerts[index].matcher_currency = rate.matcher_currency.toUpperCase();
                });

                if (vm.rateAlerts.length > 0) {
                    vm.selectedAlert = vm.rateAlerts[vm.rateAlerts.length - 1];
                    vm.selectedTab = vm.rateAlerts.length - 1;
                } else {
                    // this is important. Setting selected alert as undefined allows the props' default
                    // data to be used.
                    vm.createRateAlert();
                }
            }

            function error(err) {
                vm.loading = vm.loading.filter((element) => element !== 'loading rate alerts');
                vm.loading = vm.loading.filter((element) => element !== 'rate alert');
                vm.$swal({
                    type: 'error',
                    title: 'Error loading rate alerts',
                    text: err,
                });
            }
        }

        /**
         * Allows form component to emit loading events
         */
        function pushToLoading(message) {
            const vm = this;
            vm.loading.push(`${message}`);
        }

        // If a user clicks the tab of a yet-to-be-saved alert, it breaks the form
        // setting the alert as undefined allows the props' default data to be used.
        function select(alert) {
            const vm = this;
            if (!alert.matcher_currency || !alert.poster_currency) {
                vm.selectedAlert = undefined;
            } else {
                vm.selectedAlert = alert;
            }
        }
    }
</script>

<style>
.form {
    max-width: 400px;
}

.v-input--switch .v-label {
    font-size: 0.75em;
    padding-left: 5px;
}
</style>
